// Types
import {
  INormalizedTennisMatch,
  INormalizedTournamentData,
  ITennisConfig,
  ITennisMatch,
  ITennisMatchList,
  SDKDateOptions,
} from '../../../../packages/types';

// Constants
import { Sports } from '../../../../packages/constants/sportType';
import { SHORT_NAME } from '../../../../packages/constants/nameTypes';

// Misc
import { normalizeTournamentData } from '@sportal365/smp-widget-normalizers';
import { normalizeTennisMatchData } from './normalizeTennisMatchData';

interface INormalizeTennisTournamentResponseDataArgs {
  livescore?: ITennisMatchList[];
  dataEntityLinks?: ITennisConfig['dataEntityLinks'];
  sdkDateOptions?: SDKDateOptions;
}

type NormalizedTennisTournamentResponseData =
  | {
      matches: (void | INormalizedTennisMatch)[];
      competition: INormalizedTournamentData | undefined;
    }[]
  | undefined;

export const normalizeTennisTournamentResponseData = ({
  livescore,
  dataEntityLinks,
  sdkDateOptions,
}: INormalizeTennisTournamentResponseDataArgs): NormalizedTennisTournamentResponseData => {
  if (!livescore) return;

  return livescore.map(({ tournament, matches }) => {
    const normalizedMatches = matches.map((match: ITennisMatch) =>
      normalizeTennisMatchData({
        match: match,
        dataEntityLinks,
        dataShortStatusType: SHORT_NAME,
        sdkDateOptions,
      }),
    );
    const normalizedTournament = normalizeTournamentData({ tournament: tournament, dataEntityLinks, sport: Sports.TENNIS });

    return { matches: normalizedMatches, competition: normalizedTournament };
  });
};
